$(document).ready(() => {
	const $body = $('body');

	const styleElement = document.createElement("style");
	$body[0].appendChild(styleElement);

	const ws = new ReconnectingWebSocket('wss://www.investaz.az/quotes');
	ws.debug = true;
	let isInit = false;
	const orderArray = [
		"EURUSD",
		"GBPUSD",
		"USDCHF",
		"USDJPY",
		"USDCAD",
		"USDTRY",
		"USDRUB",
		"AUDUSD",
		"NZDUSD",
		"XAUUSD",
		"GRAMUSD",
		"XAGUSD",
		"OILUK",
		"OILUS",
		"NATG",
		"DOWJ",
		"SP500",
		"DXY",
		"APPLE",
		"BOEING",
		"BOA",
		"DISNEY",
		"GE",
		"GM",
		"HP",
		"IBM",
		"INTEL",
		"JOHNSON",
		"JPMORGAN",
		"COCACOLA",
		"MCDONALDS",
		"MICROSOFT",
		"PFIZER",
		"PG",
		"VERIZON",
		"WALLMART",
		"EXXON",
		"CHEVRON",
		"CISCO",
		"GOLDMAN",
		"TESLA",
		"ALIBABA",
		"FACEBOOK",
		"GOOGLEA",
		"TWITTER",
		"FORD",
		"NETFLIX",
		"AMAZON",
		"FEDEX",
		"FERRARI",
		"NIKE",
		"MOODYS",
		"RLAUREN",
		"VISA",
		"WUNION",
		"BLACKROCK",
		"ORACLE",
		"STARBUCKS",
		"BHATHAWAY",
		"SNAPCHAT",
		"BTCUSD",
		"ETHUSD",
		"XRPUSD",
		"DOGEUSD",
		"SOLUSD"
	];
	const ignoredSymbols = [
		"EURJPY",
		"EURGBP",
		"EURCAD",
		"EURCHF",
		"EURAUD",
		"EURTRY",
		"EURDKK",
		"EURHUF",
		"EURNOK",
		"EURNZD",
		"EURPLN",
		"EURRUB",
		"EURSEK",
		"GBPCHF",
		"GBPJPY",
		"GBPAUD",
		"GBPCAD",
		"GBPNZD",
		"GBPTRY",
		"USDDKK",
		"USDHKD",
		"USDHUF",
		"USDMXN",
		"USDNOK",
		"USDPLN",
		"USDSEK",
		"USDSGD",
		"USDZAR",
		"AUDCAD",
		"AUDCHF",
		"AUDJPY",
		"AUDNZD",
		"CADJPY",
		"CADCHF",
		"NZDCAD",
		"NZDCHF",
		"NZDJPY",
		"CHFJPY",
		"TRYJPY",
		"USDAZN",
		"EURAZN",
		"TRYAZN",
		"PLATINUM",
		"WHEAT",
		"#AAPL",
		"GBPSGD",
		"GBPNOK",
		"XPTUSD",
		"XPDUSD",
		"COPPER",
		"XAUEUR",
		"XAGEUR",
		"GRAMTL",
		"COTTON",
		"SUGAR",
		"DOGALG",
		"PETROLUK",
		"PETROLUS",
		"WTI",
		"NZDSGD",
		"SGDJPY",
		"FTSE100",
		"NIKKEI",
		"CAC40",
		"NATURALG",
		"FTSE",
		"AAPL",
		"AA",
		"AXP",
		"BA",
		"BAC",
		"C",
		"CCE",
		"DELL",
		"DD",
		"DIS",
		"GE",
		"GM",
		"HD",
		"HON",
		"HPQ",
		"INTC",
		"JNJ",
		"JPM",
		"MCD",
		"MO",
		"MRK",
		"MSFT",
		"PFE",
		"PG",
		"T",
		"UTX",
		"VZ",
		"WMT",
		"XOM",
		"AIG",
		"CITIGROUP",
		"AMERICANE",
		"CAT",
		"HDAVIDSON",
		"MMM",
		"ATT",
		"LTCUSD",
		"BCHUSD",
		"DASHUSD",
		"DOTUSD",
		"LINKUSD"
	];
	ws.onmessage = (event) => {
		try{
			let data = JSON.parse(event.data);
			const fs = event.data.substring(0,1);
			if(fs === "{")data = [data];
			if(!isInit)data = sortWithOrderFirst(data, orderArray);
			let updateStyle = false;
			for (let i in data){
				let v = data[i]
				const sym = clearSymbolName(v[1]);
				if(ignoredSymbols.indexOf(v[1])>-1)continue;

				const selector = `#ticker li.sym_${sym} span`;
				let span = $(selector);
				if(span.length === 0){
					$('#ticker ul').each(function(){
						$(`<li class="sym_${sym}"><img src="/icons/${v[1]}.svg" onerror="this.onerror=null; this.src='/icons/Default.svg';" /><label>${v[1]}</label><span class="${v[0]}">${v[2]}</span></li>`).appendTo(this);
					});
					span = $(selector);
				}
				span.html(v[2]);
				span.attr('class', v[0]);

				const li = $(`#ticker ul:first li.sym_${sym}`);
				const liWidth = Math.ceil(li[0].getBoundingClientRect().width);
				if(!li.data('width') || liWidth != li.data('width')){
					li.data('width', liWidth);
					updateStyle = true;
				}

			}
			if(!isInit || updateStyle){
				isInit = true;
				updateStyles();
			}
		}catch (e){
			console.log(e);
		}
	};
	let speed = 13;
	window.updateSpeed = (t) => {
		if(isPositiveInteger(t)){
			const oldSpeed = speed;
			speed = t;
			updateStyles();
			console.log(`✓ Animation speed changed: ${oldSpeed} → ${t}`);
		}
		else console.warn(`⚠️ Invalid speed value: ${t}. Speed must be a positive integer.`);
	};
	const updateStyles = function () {
		var e = styleElement.sheet;
		var t = $('#ticker ul:first')[0].getBoundingClientRect().width;
		var i = "marquee";
		var s = ["@keyframes " + i + " {\n\t\t\t\tfrom { transform: translateX(0); }\n\t\t\t\tto { transform: translateX(-" + t + "px); }\n\t\t\t}", "#ticker {\n\t\t\t\tanimation-duration: " + (t / speed) + "s;\n\t\t\t\tanimation-name: " + i + ";\n\t\t\t}"];
		if (e) {
			while (e.cssRules.length > 0){
				e.deleteRule(0);
			}
			for (var a = 0; a < s.length; a++)
				e.insertRule(s[a], a)
		}
	}
	let updateTime = null;
	const script = $('script[src*="js/script.min.js"]');
	if(script.length){
		const url = parseUri(script.attr('src'));
		updateTime = url.queryKey['_t'];
		setInterval(()=>{
			$.get('/')
				.done((data)=>{
					console.log('get',data);
					const html = $(data);
					const script = html.filter('script[src*="js/script.min.js"]').first();
					if(script.length){
						const url = parseUri(script.attr('src'));
						if(typeof url.queryKey['_t'] !== "undefined" && url.queryKey['_t'] !== updateTime){
							window.location.reload();
						}
					}
				});
		}, 3600000);
	}

});
function clearSymbolName(name){
	return name.toString().replace(/\W/g, '').toLowerCase();
}
//Parse Uri
const parsedUri = [];
function parseUri (str,u) {
	if(parsedUri[str] !== u)return parsedUri[str];
	var	o   = {
			strictMode: false,
			key: ["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],
			q:   {
				name:   "queryKey",
				parser: /(?:^|&)([^&=]*)=?([^&]*)/g
			},
			parser: {
				strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
				loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
			}
		},
		m   = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
		uri = {},
		i   = 14;

	while (i--) uri[o.key[i]] = m[i] || "";

	uri[o.q.name] = {};
	uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
		if ($1) uri[o.q.name][$1] = $2;
	});
	parsedUri[str] = uri;
	return uri;
}
function isPositiveInteger(value) {
	return Number.isInteger(value) && value > 0;
}

function sortWithOrderFirst(dataArray, orderArray) {
	const orderSet = new Set(orderArray);

	const orderedItems = [];
	const remainingItems = [];

	dataArray.forEach(item => {
		const symbol = item["1"];
		if (orderSet.has(symbol)) {
			orderedItems.push(item);
		} else {
			remainingItems.push(item);
		}
	});

	orderedItems.sort((a, b) => {
		const indexA = orderArray.indexOf(a["1"]);
		const indexB = orderArray.indexOf(b["1"]);
		return indexA - indexB;
	});

	return [...orderedItems, ...remainingItems];
}